import * as React from 'react';
import { SkeletonBox, ErrorState } from '@leagueplatform/web-common-components';
import { useGetIsImpersonator } from '@leagueplatform/auth-utils';
import { StackLayout } from '@leagueplatform/genesis-core';
import { useAchievementsPage } from '../../hooks/achievements-page.hook';
import { MilestoneSection } from '../milestone-section/milestone-section.view';
import { ViewProgramLibraryPlaceholder } from '../view-programs-library-placeholder/view-programs-library-placeholder.view';
import { BadgeCard } from '../badge-card/badge-card.view';

type UserAchievementsProps = {
  errorComponent: React.ReactElement;
};

export const UserAchievements = ({ errorComponent }: UserAchievementsProps) => {
  const { userAchievements, error, userAchievementsIsLoading } =
    useAchievementsPage();
  const isImpersonationSession = useGetIsImpersonator();

  if (error) {
    if (isImpersonationSession) {
      return <ErrorState error={error} />;
    }
    return errorComponent;
  }

  if (userAchievementsIsLoading) {
    return (
      <SkeletonBox data-testid="loading-skeleton" width="100%" height="250px" />
    );
  }

  return (
    <StackLayout>
      {userAchievements.map(
        ({ category_title, tooltip, completed, in_progress, empty }) => {
          const allCompletedAndInProgressAchievementsInCategory = [
            ...(completed || []),
            ...(in_progress || []),
          ];
          return (
            <MilestoneSection
              title={category_title}
              description={tooltip.description}
              key={category_title}
            >
              {allCompletedAndInProgressAchievementsInCategory.length > 0 ? (
                allCompletedAndInProgressAchievementsInCategory.map(
                  (achievement, index) => (
                    <BadgeCard
                      key={achievement.id}
                      achievement={achievement}
                      categoryTitle={category_title}
                      cardIndex={index}
                    />
                  ),
                )
              ) : (
                <ViewProgramLibraryPlaceholder
                  title={empty?.title}
                  description={empty?.description}
                  cta={empty?.cta}
                />
              )}
            </MilestoneSection>
          );
        },
      )}
    </StackLayout>
  );
};
